import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ShieldAlert, ArrowLeft } from 'lucide-react';
import '../styles/auth.css'; // Reuse auth styles or define layout inline

const Unauthorized = () => {
  const navigate = useNavigate();

  const containerStyle = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '80vh',
    background: 'radial-gradient(circle at center, #1e1e2f 0%, #0d0d15 100%)',
    padding: '2rem',
    color: 'var(--color-text-primary)',
    fontFamily: "'Outfit', 'Inter', sans-serif"
  };

  const cardStyle = {
    background: 'rgba(255, 255, 255, 0.03)',
    backdropFilter: 'blur(16px)',
    border: '1px solid rgba(255, 255, 255, 0.08)',
    borderRadius: '24px',
    padding: '3rem 2.5rem',
    maxWidth: '480px',
    width: '100%',
    textAlign: 'center',
    boxShadow: '0 20px 40px rgba(0, 0, 0, 0.4), inset 0 1px 0 rgba(255, 255, 255, 0.1)',
    transition: 'transform 0.3s ease'
  };

  const iconContainerStyle = {
    display: 'inline-flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '80px',
    height: '80px',
    borderRadius: '50%',
    background: 'linear-gradient(135deg, rgba(239, 68, 68, 0.2) 0%, rgba(249, 115, 22, 0.2) 100%)',
    border: '1px solid rgba(239, 68, 68, 0.4)',
    marginBottom: '2rem',
    color: '#f97316',
    boxShadow: '0 8px 20px rgba(239, 68, 68, 0.15)'
  };

  const headingStyle = {
    fontSize: '2rem',
    fontWeight: '700',
    background: 'linear-gradient(to right, #f97316, #ef4444)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    marginBottom: '1rem',
    letterSpacing: '-0.5px'
  };

  const textStyle = {
    fontSize: '1rem',
    color: '#9ca3af',
    lineHeight: '1.6',
    marginBottom: '2rem'
  };

  const buttonStyle = {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '0.5rem',
    background: 'linear-gradient(135deg, #f97316 0%, #ef4444 100%)',
    color: 'var(--color-text-primary)',
    border: 'none',
    borderRadius: '12px',
    padding: '0.8rem 1.8rem',
    fontSize: '1rem',
    fontWeight: '600',
    cursor: 'pointer',
    boxShadow: '0 4px 15px rgba(239, 68, 68, 0.3)',
    transition: 'all 0.2s ease',
    outline: 'none'
  };

  return (
    <div style={containerStyle}>
      <div style={cardStyle}>
        <div style={iconContainerStyle}>
          <ShieldAlert size={40} className="animate-pulse" />
        </div>
        <h1 style={headingStyle}>Access Denied</h1>
        <p style={textStyle}>
          You do not have the required administrative permissions to access this page. If you believe this is an error, please contact support or switch accounts.
        </p>
        <button
          style={buttonStyle}
          onClick={() => navigate('/')}
          onMouseOver={(e) => {
            e.currentTarget.style.transform = 'translateY(-2px)';
            e.currentTarget.style.boxShadow = '0 6px 20px rgba(239, 68, 68, 0.4)';
          }}
          onMouseOut={(e) => {
            e.currentTarget.style.transform = 'none';
            e.currentTarget.style.boxShadow = '0 4px 15px rgba(239, 68, 68, 0.3)';
          }}
        >
          <ArrowLeft size={18} />
          Back to Home
        </button>
      </div>
    </div>
  );
};

export default Unauthorized;
